<template>
  <v-snackbar
    v-if="current"
    :key="current.id"
    :model-value="true"
    :color="current.type"
    :timeout="current.timeout === 0 ? -1 : current.timeout"
    location="bottom right"
    multi-line
    @update:model-value="onClose"
  >
    <div v-if="current.title" class="font-weight-bold mb-1">{{ current.title }}</div>
    <div>{{ current.text }}</div>

    <template #actions>
      <v-btn variant="text" icon="mdi-close" size="small" @click="dismissCurrent" />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
/**
 * Renderiza la cola de notificaciones. Reemplaza a <notifications group="main">
 * de vue-notification.
 *
 * Muestra una a la vez y avanza al cerrarse: apilarlas competía con el layout de
 * Vuetify y era peor de leer.
 */
import { storeToRefs } from "pinia";
import { useNotificationsStore } from "@/stores/notifications";

const store = useNotificationsStore();
const { current } = storeToRefs(store);

function dismissCurrent() {
  if (current.value) store.dismiss(current.value.id);
}

/** v-snackbar emite false cuando expira su timeout. */
function onClose(value: boolean) {
  if (!value) dismissCurrent();
}
</script>
